import styled, { css } from 'styled-components';

const colors = (type) => {
  const color = `--dropdown-${type}`;

  return css`
    color: var(${color});

    > svg {
      color: var(${color});
    }

    :hover {
      color: var(${color}-hover);

      > svg {
        color: var(${color}-hover);
      }
    }
  `;
};

export const Wrapper = styled.div`
  position: relative;
  display: inline-block;
  text-align: left;
`;

export const Trigger = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: var(--border-radius);
  background: none;
  cursor: pointer;
  color: var(--text);
  padding: 0;
  border: none;

  &:hover:not(:disabled) {
    background-color: var(--action-hover-bg);

    ${({ alternate }) =>
      alternate &&
      css`
        background-color: var(--dropdown-bg-hover-alternate);
      `};
  }

  &:disabled {
    background: none;
    opacity: 0.5;
    cursor: default;
  }
`;

export const Item = styled.li`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  padding: var(--xs-padding);
  cursor: pointer;

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.7;
      cursor: not-allowed;
      pointer-events: none;
    `}

  :first-child {
    border-radius: var(--border-radius) var(--border-radius) 0 0;
  }

  :last-child {
    border-radius: 0 0 var(--border-radius) var(--border-radius);
  }

  :only-child {
    border-radius: var(--border-radius);
  }

  &:hover {
    background-color: var(--dropdown-menu-item-hover-bg);
  }

  > svg {
    margin-right: var(--xs-padding-horizontal);
  }

  ${({ accent }) => colors(accent)};
`;

export const Menu = styled.ul`
  position: absolute;
  right: 0;
  top: calc(100% + 3px);
  font-size: var(--font-size) !important;
  font-weight: normal !important;

  margin-top: var(--xs-padding-vertical);
  width: max-content;
  box-shadow: var(--box-shadow);
  z-index: 500;
  border-radius: var(--border-radius);

  background-color: var(--dropdown-menu-bg);
  border: 1px solid var(--dropdown-menu-border-color);
`;

export const Separator = styled.div`
  height: 1px;
  background-color: var(--dropdown-menu-border-color);
`;
